import { IComponentStyle } from '@kurtosys/types/componentStyle/IComponentStyle.js';

import { ITheme } from '../models/ITheme.js';

export function getComponentStyle<K extends keyof Omit<ITheme, 'fontFaces'>>(
	theme: ITheme | undefined,
	categoryKey: K,
	componentKey: string,
	...childKeys: string[]
): IComponentStyle | undefined {
	let response: IComponentStyle | undefined = undefined;
	if (theme) {
		const category: { [key: string]: IComponentStyle | undefined } = (theme || {})[categoryKey] as {
			[key: string]: IComponentStyle | undefined;
		};
		if (category) {
			response = category[componentKey];
			if (childKeys) {
				for (const childKey of childKeys) {
					if (response && response.children && (response.children as any)[childKey]) {
						response = (response.children as any)[childKey];
					} else {
						response = undefined;
						break;
					}
				}
			}
		}
	}
	return response;
}